import { Box } from '@mui/material';
import Spinner from 'components/spinner/spinner.component';
import { useState, useEffect } from 'react';

const DelayedRender = ({ delay = 1500, children }) => {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldRender(true);
    }, delay);

    return () => clearTimeout(timer); // Cleanup on unmount
  }, [delay]);

  return shouldRender ? (
    children
  ) : (
    <Box position="relative" height="100%" width="100%">
      <Spinner />
    </Box>
  );
};

export default DelayedRender;
